import { Spacing } from '@vkontakte/vkui';
import classNames from 'clsx';
import { ReactComponent as CloudLogoFooter } from 'img/nestleLanding/Logo_Footer.svg';
import { ReactComponent as QR } from 'img/nestleLanding/QR.svg';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { Rating } from 'reactApp/sections/Nestle/Rating/Rating';
import { RatingWithApplications } from 'reactApp/sections/Nestle/RatingWithApplications/RatingWithApplications';
import { sendQuotaGa } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import StoreButton, { type EStoreType } from 'reactApp/ui/StoreButton/StoreButton';

import styles from './FooterNestle.css';

export const FooterNestle = () => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);
    const mobileType = useSelector(EnvironmentSelectors.getMobileType) as EStoreType;

    const onClick = useCallback((type) => {
        sendQuotaGa({ action: 'app', label: 'click', name_app: `cloud_${type}`.toLowerCase() });
    }, []);

    return (
        <div
            className={classNames(styles.footer, {
                [styles.footerPhone]: isMobile,
            })}
        >
            <div
                className={classNames(styles.info, {
                    [styles.infoPhone]: isMobile,
                })}
            >
                <div
                    className={classNames(styles.left, {
                        [styles.leftPhone]: isMobile,
                    })}
                >
                    <a
                        className={classNames(styles.url, {
                            [styles.urlPhone]: isMobile,
                        })}
                        href={isMobile ? 'https://blog.mail.ru/pravila_pereklichka_po_klichkam/' : 'https://vk.cc/cPc119'}
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        Правила акции
                    </a>
                    <Spacing size={12} />
                    <a
                        className={classNames(styles.url, {
                            [styles.urlPhone]: isMobile,
                        })}
                        href="https://vk.cc/cKeeiP"
                        rel="nofollow noreferrer"
                        target="_blank"
                    >
                        Условия безлимитной памяти
                    </a>
                    <div
                        className={classNames(styles.title, {
                            [styles.titlePhone]: isMobile,
                        })}
                    >
                        Доступно на всех устройствах
                    </div>
                    <div
                        className={classNames(styles.description, {
                            [styles.descriptionPhone]: isMobile,
                        })}
                    >
                        Облако безопасно сохранит тысячи ваших&nbsp;файлов, упростит обмен и&nbsp;сэкономит память в&nbsp;телефоне
                    </div>
                    {!isMobile && <Rating />}
                </div>
                {!isMobile ? (
                    <div className={styles.right}>
                        <div className={styles.applications}>
                            <StoreButton
                                mobileType={mobileType as EStoreType}
                                appStoreLink={'https://trk.mail.ru/c/muv7c7'}
                                googlePlayLink={'https://trk.mail.ru/c/pbnfy7'}
                                ruStoreLink={'https://apps.rustore.ru/app/ru.mail.cloud'}
                                appGalleryLink={'https://appgallery8.huawei.com/#/app/C101034901'}
                                onClick={onClick}
                            />
                        </div>
                        <div className={styles.qrBlock}>
                            <QR width="91" height="91" />
                            <div className={styles.qrInfo}>
                                <div className={styles.qrTitle}>Скачать по QR</div>
                                <div className={styles.qrDescription}>
                                    Отсканируйте QR-код <br />
                                    с помощью телефона,
                                    <br />
                                    чтобы скачать приложение
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <RatingWithApplications />
                )}
            </div>
            {isMobile && <Spacing size={36} />}
            <div className={styles.nav}>
                <a href="http://cloud.mail.ru/?utm_source=cloud&utm_medium=landing&utm_campaign=footer" target="_blank" rel="noreferrer">
                    <CloudLogoFooter width="135" height="30" />
                </a>
                {!isMobile && (
                    <div className={styles.links}>
                        <a
                            href="http://cloud.mail.ru/?utm_source=cloud&utm_medium=landing&utm_campaign=footer"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Главная
                        </a>
                        <a
                            href="https://corp.mail.ru/?utm_source=cloud&utm_medium=landing&utm_campaign=footer"
                            target="_blank"
                            rel="noreferrer"
                        >
                            О компании
                        </a>
                        <a href=" https://vk.cc/cPc1qb" target="_blank" rel="noreferrer noopener">
                            Помощь
                        </a>
                        <a
                            href="https://disk-o.cloud/?utm_source=cloud&utm_medium=landing&utm_campaign=footer"
                            rel="nofollow noreferrer"
                            target="_blank"
                        >
                            Облако для ПК
                        </a>
                        <a
                            href="https://screenshoter.mail.ru/?utm_source=cloud&utm_medium=landing&utm_campaign=footer"
                            target="_blank"
                            rel="nofollow noreferrer"
                        >
                            Скриншотер
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};
